import { render, staticRenderFns } from "./typings.componentV2.vue?vue&type=template&id=0f8f84b4&scoped=true&"
import script from "./typings.componentV2.vue?vue&type=script&lang=js&"
export * from "./typings.componentV2.vue?vue&type=script&lang=js&"
import style0 from "./typings.componentV2.vue?vue&type=style&index=0&id=0f8f84b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f84b4",
  null
  
)

export default component.exports